import { label } from "framer-motion/client";

// src/data/tocMap.js
export const tocMap = {
  exploreNetraa: [
    { id: "suite-overview", label: "Suite Overview" },
    { id: "product-grid", label: "Product Grid" },
    // { id: "architecture", label: "the Netraa Difference" },
  ],

  gettingStarted: [
    { id: "introduction", label: "Introduction" },
    { id: "key-differentiators", label: "Key Differentiators" },
    { id: "workflow-integration", label: "Workflow Integration" },
    { id: "who-should-use", label: "Who Should Use" },
  ],

  quickStart: [
    { id: "add-application", label: "Add Application" },
    { id: "install-agent", label: "Install Agent" },
    { id: "view-traces", label: "View Traces" },
    { id: "analyze-bottleneck", label: "Analyze Bottleneck" },
  ],

  netraaAPM: [
    { id: "architecture", label: "Netraa Platform Architecture" },
    { id: "prerequisites", label: "Common Prerequisites" },
    { id: "master-sizing", label: "Environment Specifications Matrix" },
    { id: "docker-install", label: "Docker & Docker Compose" },
    { id: "part-1", label: "PART 1: Database Layer" },
    { id: "part-2", label: "PART 2: AOP Layer" },
    { id: "part-3", label: "PART 3: Netraa APM Layer" },
    { id: "license-activation", label: "License Activation & Finalization" }
    // { id: "docker-installation", label: "Docker Installation" },
    // { id: "db-image-loading", label: "Database Image Loading" },
    // { id: "db-deployment", label: "Database Deployment" },
    // { id: "aop-installation", label: "AOP Installation" },
  ],
    platformOverview: [
    { id: "architecture", label: "Architecture" },
    { id: "data-flow", label: "Data Flow Model" },
    { id: "security-overview", label: "Security Overview" },
  ],

  coreConcept: [
    { id: "service-model", label: "Services & Instances" },
    { id: "telemetry-correlation", label: "Traces vs Logs vs Metrics" },
    { id: "infra-groups", label: "Infrastructure Groups" },
    // { id: "dependency-model", label: "Dependency Model" },
    // { id: "next-steps", label: "Continue Learning" }
  ],
    appOverview: [
    { id: "technical-overview", label: "Technical Overview" },
    { id: "application-overview", label: "Application Overview" },
    { id: "infra-overview", label: "Infra Group Overview" },
  ],

  generalServices: [
    { id: "service-overview", label: "Service Overview & Topology" },
    { id: "distributed-traces", label: "Distributed Traces & Logs" },
    { id: "database-visibility", label: "Database Visibility" },
    { id: "instance-level", label: "Instance Level Monitoring" },
    { id: "endpoint-level", label: "Endpoint Level Monitoring" },
  ],

  infraMonitoring: [
    { id: "host-monitoring", label: "Host Monitoring" },
    { id: "container-monitoring", label: "Container Monitoring" },
    { id: "nginx-monitoring", label: "NGINX Monitoring" },
    { id: "redis-monitoring", label: "Redis Monitoring" },
  ],

  databaseMonitoring: [
    { id: "mysql-monitoring", label: "MySQL Monitoring" },
    { id: "mssql-monitoring", label: "MSSQL Monitoring" },
    { id: "correlated-insights", label: "Correlated Insights" },
  ],

  browserMonitoring: [
    { id: "browser-monitoring", label: "Browser Monitoring" },
    { id: "mobile-monitoring", label: "Mobile Monitoring" },
  ],
  
  msgmq: [
  { id: "activemq", label: "ActiveMQ Monitoring" },
  { id: "kafka", label: "Kafka Monitoring" },
  { id: "advantage", label: "Netraa Advantage" },
],
 alert: [
  { id: "health-rules", label: "Health Rules" },
  { id: "alert-routing", label: "Alert Configuration" },
  { id: "alert-history", label: "Alert History" },
],
report: [
  // { id: "performance-reports", label: "Performance Reports" },
  { id: "html-reports", label: "HTML Reports" },
  { id: "observability-loop", label: "Closing the Observability Loop" },
],
analytics: [
  { id: "latency-trends", label: "Latency Trends" },
  { id: "error-rate-trends", label: "Error Rate Trends" },
  { id: "slow-endpoints", label: "Slow Endpoint Reports" },
  { id: "dependency-health", label: "Dependency Health" },
],
integration: [
  { id: "integrations-overview", label: "Overview" },
  { id: "jira-integration", label: "ITSM & Incident Management" },
  { id: "integration-ecosystem", label: "Supported Integration Ecosystem" },
  { id: "integration-strategy", label: "Integration Strategy & Benefits" },
],
prerequisitesAPM: [
  { id: "introduction", label: "Overview" },
  { id: "master-sizing", label: "Environment Specifications Matrix" },
  { id: "software-requirements", label: "Software Requirements" },
  { id: "firewall-policy", label: "Firewall Policy" },
  { id: "access", label: "Access" }
],
Agent: [
  { id: "one-agent", label: "Netraa infra Setup Guide" },
  { id: "java-agent", label: "Netraa Java Agent Setup" },
  { id: "platform-specific", label: "Platform-Specific Commands" },
  { id: "log-monitoring", label: "Log Monitoring with Java Agent" }
],
Minimal: [
  { id: "architecture", label: "Minimal Setup Architecture" },
  { id: "db-layer", label: "Database Layer Installation" },
  { id: "aop-layer", label: "AOP Layer Installation" },
  { id: "apm-layer", label: "Netraa APM Layer Installation" },
  { id: "license-activation", label: "License Activation & First Login" }
],
AiOverview: [
  { id: "architecture", label: "Netraa AIOps Architecture" },
  { id: "core-problem", label: "Core Problem & Solution" },
  { id: "observability-universe", label: "Observability Universe" },
  { id: "ai-capabilities", label: "Platform Capabilities" },
],

AiopsSetup: [
  { id: "database-layer", label: "Database Layer" },
  { id: "backend-layer", label: "Backend Layer" },
  { id: "backend-env-config", label: "Backend Environment Configuration" },
  { id: "gateway-layer", label: "Gateway Layer (Nginx)" },
  { id: "llm-integration", label: "LLM Server Integration" },
  { id: "high-level-flow", label: "High-Level Flow" },
  { id: "best-practices", label: "Notes / Best Practices" },
  { id: "frontend-layer", label: "Frontend Layer (Browser Extension)" },
],
ragDoc: [
  { id: "knowledge-bridge", label: "Docs-Aware Reasoning (RAG Overview)" },
  { id: "operational-scramble", label: "The Problem: Fragmented Knowledge & Slow MTTR" },
  { id: "rag-assistant", label: "The Solution: Merging Observability with Knowledge" },
],
correlation: [
  { id: "feature-overview", label: "Universal Event Correlation Overview" },
  { id: "the-problem", label: "The Problem: Fragmented Visibility & Alert Noise" },
  { id: "intelligent-solution", label: "The Solution: Intelligent Ingestion to Unified Timeline" },
],
genAi: [
  { id: "paradigm-shift", label: "GenAI Interpretive Intelligence Overview" },
  { id: "dashboard-fatigue", label: "The Problem: Dashboard Fatigue" },
  { id: "narrative-solution", label: "The Solution: From Visual Artifacts to Intelligent Narratives" },
],

predictiveModeling: [
  { id: "predictive-overview", label: "Predictive Modelling Overview" },
  { id: "reactive-chaos", label: "The Problem: Reactive Operations" },
  { id: "future-proof-engine", label: "The Solution: Multi-Factor Engine" },
],

causalAi: [
  { id: "causal-hero", label: "Causal AI Overview" },
  { id: "correlation-problem", label: "The Problem: Correlation vs Causation" },
  { id: "precision-solution", label: "The Solution: Precision Engine" },
],
AiOpsintegration: [
  { id: "ticket-hero", label: "Deep Ticket Enrichment Overview" },
  { id: "manual-effort-gap", label: "The Problem: Manual Effort & Stale Context" },
  { id: "actionable-workflow", label: "The Solution: Actionable Intelligence & Real-Time Sync" },
],
netraaLH: [
  { id: "what-is-synthetic", label: "What is Synthetic Monitoring?" },
  { id: "netraa-fit", label: "Where Netraa LH Comes into the Picture" },
  { id: "working-model", label: "How Does Netraa LH Work? (The BFSI Standard)" },
  { id: "monitoring-types", label: "Types of Netraa LH Monitoring" },
  { id: "value-prop", label: "The Value Proposition" },
  { id: "login-access", label: "Accessing Netraa LH" },
],
Dashboard: [
  { id: "kpi-dashboard", label: "KPI Dashboard" },
  { id: "filters", label: "Filter Controls" },
  { id: "live-execution", label: "Live Dashboard" },
  { id: "performance-analytics", label: "Performance Analytics" },
],
Availability: [
  { id: "synthetic-execution", label: "Synthetic Execution" },
  { id: "execution-overview", label: "Execution Overview" },
  { id: "page-availability", label: "Page Availability Details" },
  { id: "detailed-results", label: "Synthetic Execution Details" },
],
ErrorSLA: [
  { id: "error-dashboard", label: "Error Dashboard" },
  { id: "error-statistics", label: "Detailed Error Statistics" },
  { id: "sla-management", label: "SLA Management" },
  { id: "device-selection", label: "Domain & Device Selection" },
  { id: "kpi-views", label: "SLA KPI Views" },
],
reportLH: [
  { id: "errors-overview", label: "Errors Overview" },
  { id: "adding-exceptions", label: "Add Maintenance Exception" },
  { id: "bulk-uploads", label: "Bulk Uploads" },
  { id: "single-bulk-reports", label: "Reports (Single & Bulk)" },
  { id: "email-configuration", label: "Manage (Email Configuration)" },
],
netraaLHConcepts: [
  { id: "introduction", label: "Benchmarking Selection" },
  { id: "key-metrics", label: "Key Metrics Analysis" },
  { id: "strategic-benefits", label: "Strategic Benefits" },
],

agentlinux: [
  {id: "one-agent", label: "Netraa infra setup guide"},
 
],
agentwindows: [
  { id: "windows-intro", label: "Overview" },
  { id: "windows-prerequisites", label: "Prerequisites" },
  { id: "steps", label: "Steps to follow" },
],
network: [
  { id: "Introduction", label: "Overview" },
  { id: "overview", label: "Deployment Overview" },
  { id: "rechability", label: "Network Reachability" },
  { id: "firewall", label: "Firewall / Whitelisting" },
  { id: "snmp", label: "SNMP v2c Configuration" },
  { id: "validation", label: "SNMP Validation" },
  { id: "configuration", label: "Netraa Configuration" }
],
agentjava: [
  { id: "introo", label: "Overview" },
  { id: "steps to follow", label: "Steps to follow" },
  { id: "logs monitoring", label: "Logs Monitoring" },
],
agentpython: [
  { id: "introduction", label: "Overview" },
  { id: "prerequisites", label: "Prerequisites" },
  { id: "installation", label: "Steps to follow" },
  { id: "microservices", label: "Running Netraa in a Microservices Architecture" },
],
agentdotnet: [
  { id: "introduction", label: "Overview" },
  { id: "linux", label: "Linux Deployment SOP" },
  { id: "windows", label: "Windows Deployment SOP" },
  { id: "verification", label: "Verification & Troubleshooting" },
],
agentphp: [
  { id: "apmosys-agent", label: "PHP Agent Installation" },
],
agentnodejs: [
  { id: "Overview", label: "Overview" },
  { id: "steps-to-follow", label: "Steps to Follow" },
],
agentmysql: [
  { id: "installation", label: "Installation Steps" },
  { id: "usage", label: "Usage" },
  { id: "environment", label: "Environment Specifications" },
],
agentoracle: [
  { id: "introduction", label: "Overview" },
  { id: "troubleshooting", label: "Troubleshooting" },
  { id: "download-agent", label: "Oracle Agent Overview" },
  { id: "env-specs", label: "Environment Specification Table" },
],
activemq: [
  {id: "Active MQ Integration", label:"Active MQ Integration"}
],
agentkafka: [
  { id: "Introduction", label: "Overview" },
  { id: "steps to follow", label: "Steps to Follow" },
],
agentmssql:[
  { id: "introduction", label: "Introduction" },
  { id: "installation", label: "Installation" },
],

agentazurevm:[
  { id: "overview", label: "Overview" },
],
agentawsrds:[
  { id: "overview", label: "Overview" },
  { id: "prerequisites", label: "Prerequisites" },
  { id: "steps", label: "Steps to follow" },
],
agentawsgateway: [
  { id: "overview", label: "Overview" },
  { id: "prerequisites", label: "Prerequisites" },
  { id: "steps", label: "Steps to follow" },
  { id: "data-flow", label: "Data Flow" },
],
agentawseks: [
  { id: "overview", label: "Overview" },
  { id: "prerequisites", label: "Prerequisites" },
  { id: "configuration", label: "Configuration" },
  { id: "verify", label: "Verify Deployment" },
  { id: "metrics", label: "Metrics Collected" },
  { id: "troubleshooting", label: "Troubleshooting" },
  { id: "summary", label: "Summary" }
],
"releaseNotesv1.1": [
  { id: "introduction", label: "Overview" },
  { id: "release-notes", label: "Release Notes" },
  { id: "ui-updates", label: "UI Updates" }
],
"releaseNotesv1.5": [
  { id: "release-details", label: "Overview" },
  { id: "introduction", label: "Introduction" },
  { id: "enhancements", label: "Key Enhancements" },
  { id: "impact", label: "Impact & Business Value" },
],

"releaseNotesv1.3": [
  { id: "details", label: "Overview" },
  { id: "introduction", label: "Introduction" },
  { id: "summary", label: "Summary" },
  { id: "features", label: "Features & Enhancements" },
  { id: "performance", label: "Performance Improvements" },
  { id: "impact", label: "Impact Summary" }
],

"releaseNotesv1.2": [
  { id: "release-details", label: "Overview" },
  { id: "introduction", label: "Introduction" },
  { id: "enhancements", label: "Enhancements" }
],
"releaseNotesv1.4": [
  { id: "release-details", label: "Overview" },
  { id: "introduction", label: "Introduction" },
  { id: "enhancements", label: "Enhancements" }
],

"releaseNotesv1.0": [
  { id: "release-details", label: "Overview" },
  { id: "features", label: "New Enhancements & Fixes" },
],

releasenotesAPM: [
  { id: "overview", label: "Overview" },
  { id: "analytics", label: "Release Analytics" },
  { id: "intro", label: "Introduction" },
  { id: "enhancements", label: "Key Enhancements" },
  { id: "impact", label: "Impact & Business Value" },
],

"releasenotesAPMv2": [
  { id: "release-details", label: "Introduction" },
  { id: "enhancements", label: "Major Feature Enhancements" },
  { id: "impact", label: "Additional Notes" },
  { id: "notes", label: "Release Summary" },
],
"releasenotesAPMv3": [
  { id: "release-details", label: "Introduction" },
  { id: "analytics", label: "Release Analytics" },
  { id: "overview", label: "Release Details" },
  { id: "enhancements", label: "Major Feature Enhancements" },
  { id: "impact", label: "Additional Notes" },
  { id: "notes", label: "Release Summary" },
],

"releasenotesAPMv4": [
  { id: "release-details", label: "Introduction" },
  { id: "analytics", label: "Release Analytics" },
  { id: "enhancements", label: "Major Feature Enhancements" },
  { id: "impact", label: "Additional Notes" },
  { id: "notes", label: "Release Summary" },
],


"releasenotesAPMv6": [
  { id: "release-details", label: "Introduction" },
  { id: "analytics", label: "Release Analytics" },
  { id: "enhancements", label: "Key Enhancements" },
  { id: "notes", label: "Additional Notes & Release Summary" },
],

"releaseNotesv1.6": [
  { id: "release-details", label: "Overview" },
  { id: "introduction", label: "Introduction" },
  { id: "enhancements", label: "Release Notes" },
  { id: "impact", label: "Focus of This Release" },
],

homeservices: [
  { id: "intro", label: "Introduction" },
  { id: "accessing-services", label: "Accessing the Services Page" },
  { id: "exploring-service", label: "Exploring a Service" },
  { id: "overview", label: "Overview" },
  { id: "instance", label: "Instance" },
  { id: "endpoint", label: "Endpoint" },
  { id: "topology", label: "Topology" },
  { id: "traces", label: "Traces" },
  { id: "logs", label: "Logs" },
  { id: "database", label: "Database" },
],
infrahost: [
  { id: "intro", label: "Introduction" },
  { id: "accessing-host", label: "Accessing the Host Page" },
  { id: "exploring-host", label: "Exploring a Host" },
  { id: "overview", label: "Overview" },
  { id: "process-list", label: "Process List" },
  { id: "container", label: "Container" },
],

infraredis: [
  { id: "accessing-redis", label: "Accessing the Redis Page" },
  { id: "exploring-redis", label: "Exploring Redis in Netraa" },
  { id: "overview", label: "Overview" },
  { id: "instance", label: "Instance" },
],

apps: [
  { id: "overview", label: "Overview" }
],

configadmin: [
  { id: "create-client", label: "Step 1 – Create Client" },
  { id: "create-role", label: "Step 2 – Create Role" },
  { id: "create-user", label: "Step 3 – Create User" },
],
agentsetup: [
  { id: "overview", label: "Overview" }
],
db: [
  { id: "intro", label: "Introduction" },
  { id: "accessing-database", label: "Accessing the Database Page" },
  { id: "supported-databases", label: "Supported Database Technologies" },
  { id: "exploring-databases", label: "Exploring Databases in Netraa" },
  { id: "db-mysql", label: "MySQL" },
  { id: "db-mssql", label: "MSSQL" },
  { id: "db-oracle", label: "Oracle" },
  { id: "db-mongodb", label: "MongoDB" },
],

servicenow: [
  { id: "intro", label: "Overview" },
  { id: "purpose", label: "Purpose" },
  { id: "integration-overview", label: "Integration Overview" },
  { id: "prerequisites", label: "Prerequisites" },
  { id: "step1-oauth-app", label: "Create OAuth Application in ServiceNow" },
  { id: "step2-client-credentials", label: "Configure Client Credentials Access" },
  { id: "step3-oauth-scope", label: "Configure the OAuth Scope" },
  { id: "step4-token-endpoint", label: "Verify the OAuth Token Endpoint" },
  { id: "oauth-connectivity-test", label: "Optional OAuth Connectivity Test" },
  { id: "step5-netraa-interface", label: "Configure Netraa Interface" },
  { id: "step6-caller", label: "Configure ServiceNow Caller" },
  { id: "step7-record-type", label: "Select ServiceNow Record Type" },
  { id: "step8-create-interface", label: "Create the Interface" },
  { id: "config-example", label: "Recommended Configuration Example" },
  { id: "step9-alert", label: "Configure an Alert in Netraa" },
  { id: "end-to-end-flow", label: "End-to-End Ticket Creation Flow" },
  { id: "verify-integration", label: "How to Verify That the Integration Works" },
  { id: "troubleshooting", label: "Common Problems and Troubleshooting" },
  { id: "security-recommendations", label: "Security Recommendations" },
  { id: "configuration-checklist", label: "Configuration Checklist" },
  { id: "quick-reference", label: "Quick Reference" },
  { id: "official-references", label: "Official ServiceNow References" },
],

releasenotesAPMv5: [
  { id: "release-details", label: "Introduction" },
  { id: "analytics", label: "Release Analytics" },
  { id: "enhancements", label: "Major Feature Enhancements" },
  { id: "notes", label: "Additional Notes" },
],

netraaApmLanding:[
  {id:"overview", label: "Overview"}
]
};
